module.exports = __webpack_public_path__ + "media/images/lb/583-e80a8af48f1e7c18eb186ac329320f6b.svg";